import { useRef, useCallback } from 'react'
import { BUFFER_DAYS } from '../constants/gantt.const'
// 배경 드래그 스크롤·팬 모드 — 이동 전 GanttView.tsx 본문을 그대로 옮긴 것이다.

export type UseGanttPanArgs = {
  scrollRef: React.MutableRefObject<HTMLDivElement | null>
  closePanelGuarded: () => void
  setSelectedDepId: React.Dispatch<React.SetStateAction<number | null>>
  clampedGanttOffsetRef: React.MutableRefObject<number>
  barDragState: React.MutableRefObject<{ taskId: number; startX: number; currentOffset: number; } | null>
  barResizeState: React.MutableRefObject<{ taskId: number; startX: number; currentOffset: number; } | null>
  isPanModeRef: React.MutableRefObject<boolean>
  DWRef: React.MutableRefObject<number>
  setGanttOffset: React.Dispatch<React.SetStateAction<number>>
}

export function useGanttPan({
  scrollRef, closePanelGuarded, setSelectedDepId, clampedGanttOffsetRef, barDragState, barResizeState,
  isPanModeRef, DWRef, setGanttOffset,
}: UseGanttPanArgs) {
  const dragging           = useRef(false)
  const dragStartX         = useRef(0)
  const dragScrollL        = useRef(0)
  const panStartOffsetRef      = useRef(0)

  // ── Scroll drag (꾹 눌러 이동 — 바 외 영역) ───────────────────
  const onContainerMouseDown = useCallback((e: React.MouseEvent) => {
    if (e.button !== 0) return
    if (!scrollRef.current) return
    closePanelGuarded()
    setSelectedDepId(null)
    dragging.current          = true
    dragStartX.current        = e.clientX
    dragScrollL.current       = scrollRef.current.scrollLeft
    panStartOffsetRef.current = clampedGanttOffsetRef.current
    document.body.style.cursor    = 'grabbing'
    document.body.style.userSelect = 'none'
  }, [closePanelGuarded])

  const onContainerMouseMove = useCallback((e: React.MouseEvent) => {
    if (barDragState.current || barResizeState.current) return
    if (!dragging.current || !scrollRef.current) return
    e.preventDefault()
    if (isPanModeRef.current) {
      // 팬 모드: scrollLeft를 픽셀 단위로 직접 이동 → 부드러운 스크롤
      const dx = e.clientX - dragStartX.current
      scrollRef.current.scrollLeft = BUFFER_DAYS * DWRef.current - dx
    } else {
      scrollRef.current.scrollLeft = dragScrollL.current - (e.clientX - dragStartX.current)
    }
  }, [])

  const stopScrollDrag = useCallback(() => {
    if (barDragState.current || barResizeState.current) return
    if (!dragging.current) return
    dragging.current = false
    document.body.style.cursor    = ''
    document.body.style.userSelect = ''
    // 팬 모드: 드래그 끝에 가장 가까운 날짜로 스냅
    if (isPanModeRef.current && scrollRef.current) {
      const scrolled = scrollRef.current.scrollLeft - BUFFER_DAYS * DWRef.current
      const dayDelta = Math.round(scrolled / DWRef.current)
      setGanttOffset(panStartOffsetRef.current + dayDelta)
      // useEffect가 re-render 후 scrollLeft를 BUFFER_DAYS * DW로 복원
    }
  }, [])

  return { onContainerMouseDown, onContainerMouseMove, stopScrollDrag }
}
